module.exports = __webpack_public_path__ + "static/media/salesTransactionDashboard.7462ab4f.jpg";